export default "/d6adac113dc4b6b20658fd12c480f4e4.svg";